import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import Footer from "../../Components/Footer/footer";
import { FcEngineering } from "react-icons/fc";
import { CiCalculator1 } from "react-icons/ci";
import { useNavigate } from "react-router";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
// import { QuotationInfo } from "../../SchemaInfo/info";
// import { QuotationSchema } from "../../Schemas/quotation/quotation_schema";
import CustomSelect from "../../CustomComponent/custom_select";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import { materialPlaningInfo, materialPlanning } from "../../SchemaInfo/info";
import { materialPlaningSchemaNew } from "../../Schemas/Material Planning/materialPlaninning";
import StepRoutes from "../../Routes/steps_routes";
import CustomInput from "../../CustomComponent/custom_input";

const HydroponicMaterialPlanning = () => {
  const [length, setLength] = useState();
  const [width, setWidth] = useState();
  const [hydrponicType, setHydrponicType] = useState("flatbed");
  const [errors, setErrors] = useState({});
  const [projects, setProjects] = useState([]);
  const [clinetProject, setClientProject] = useState();
  const [planters, setPlanters] = useState();
  const [dutchbucket, setDutchBucket] = useState();
  const [sikit, setSiKit] = useState();
  const [officeitem, setOfficeItem] = useState();
  const [toolsMasonary, setToolsMasonary] = useState();
  const [loading, setLoading] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});

  const navigate = useNavigate();

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!length || isNaN(length) || length <= 0) {
  //     newErrors.length = "Please enter a valid positive number for length.";
  //   }
  //   if (!width || isNaN(width) || width <= 0) {
  //     newErrors.width = "Please enter a valid positive number for width.";
  //   }
  //   if (!hydrponicType || hydrponicType === "Select") {
  //     newErrors.hydrponicType = "Please select a hydroponic type.";
  //   }
  //   if (!clinetProject || clinetProject === "Select") {
  //     newErrors.clinetProject = "Please select a client Project.";
  //   }
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllPlanters`)
      .then((res) => {
        if (res.status === 200) {
          setPlanters(res.data.PlanterList);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllDutchBucket`)
      .then((res) => {
        if (res.status === 200) {
          setDutchBucket(res.data.DutchBucketList);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllSiKit/`)
      .then((res) => {
        if (res.status === 200) {
          setSiKit(res.data.SiKitList);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllOfficeItems/`)
      .then((res) => {
        if (res.status === 200) {
          setOfficeItem(res.data.OfficeItems);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/materialPlanning/getAllToolsMasonaries/`)
      .then((res) => {
        if (res.status === 200) {
          setToolsMasonary(res.data.ToolsMasonaries);
        } else {
          Toast("error", "Error while getting Details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handleDownload = (hydroponicType) => {
    const listToFilter =
      hydroponicType === "planters"
        ? planters
        : hydroponicType === "dutch_bucket"
        ? dutchbucket
        : hydroponicType === "sikit"
        ? sikit
        : hydroponicType === "officeItems"
        ? officeitem
        : hydroponicType === "tools"
        ? toolsMasonary
        : [];
    const printableContent = listToFilter
      .filter((item) => item?.count)
      .map((item, index) => {
        const specsArray = Array.isArray(item.specificationsNew)
          ? item.specificationsNew
          : JSON.parse(item.specificationsNew || "[]");
        const specsHTML = specsArray
          .map((type) =>
            type.specification && hydroponicType === type?.type
              ? `<span style="display: block; margin-top: 0;">${type.specification}</span>`
              : ""
          )
          .join("");

        return `<tr>
            <td style="text-align: center;">${index + 1}</td>
            <td style="text-align: center;">
              <img src="${
                item.image
              }" alt="Image" width="40px" style="display: block; margin: 0 auto;" />
            </td>
            <td>
              <b>${item.item}</b>
              ${
                item.hsn
                  ? `<br /><b style="color: gray;">HSN: ${item.hsn}</b>`
                  : ""
              }
              <br />
              ${specsHTML}
            </td>
            <td style="text-align: center;">${item.count} ${
          item.unit || ""
        }</td>
          </tr>`;
      });

    const newWindow = window.open("", "_blank");
    newWindow.document.write(`
      <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
            }
            th {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <h1 style="text-align: center;">
           Material List: ${
             hydroponicType === "planters"
               ? "100 Planters"
               : hydroponicType === "dutch_bucket"
               ? "Dutch Bucket"
               : hydroponicType === "sikit"
               ? "Si Kit"
               : hydroponicType === "officeItems"
               ? "Office Items"
               : "Tools And Machinery"
           }
          </h1>
          <table>
            <thead>
              <tr>
                <th>Sr</th>
                <th>Image</th>
                <th>Item Name</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              ${printableContent.join("")}
            </tbody>
          </table>
        </body>
      </html>
    `);

    newWindow.document.close();
    newWindow.onafterprint = () => newWindow.close();
    newWindow.print();
  };

  const handleSubmit = (values, actions) => {
    if (values) {
      navigate("/hydroponic-material-planning/table", {
        state: {
          length: values?.bay_size,
          width: values?.span_size,
          hydrponicType: values?.hydrponicType,
          hydrponicPercentage: 100,
          hydrponicPercentageFlat: values?.flatBedPercent,
          hydrponicPercentageGrow: values?.growBagPercent,
          clinetProject: values?.clientName,
        },
      });
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h2 className="page-title mb-1">
                    <FcEngineering className="fs-2  me-1" />
                    Create Material List
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes></StepRoutes>
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-12 d-md-flex">
                  <div className="col-md-3 col-sm-12 py-2 me-3">
                    <div className="card p-2 mb-3">
                      <h3 className="m-0 p-0">Notes:</h3>
                      <hr className="my-1" />
                      <ul className="mb-3">
                        <li>
                          Add length and width, including the hockey area.
                        </li>
                        <li>Length is a multiple of 4 m.</li>
                        <li>Width is a multiple of 8 m.</li>
                        <li>
                          Manually calculate the percentage of utilized area and
                          add it.
                        </li>
                      </ul>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("planters")}
                        >
                          100 PLANTERS
                        </button>
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("dutch_bucket")}
                        >
                          DUTCH BUCKET
                        </button>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("sikit")}
                        >
                          SI KIT
                        </button>
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("officeItems")}
                        >
                          OFFICE ITEMS
                        </button>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => handleDownload("tools")}
                        >
                          TOOLS AND MACHINERY
                        </button>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn flex-grow-1 m-1"
                          onClick={() => {
                            navigate("/construction-designer");
                          }}
                        >
                          COMBINED GROW + FLAT
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-9 col-sm-12 py-2">
                    <div className="card">
                      <div className="card-body">
                        <div className="mb-3">
                          <label className="form-label required">
                            Polyhouse Length (4mtr)
                          </label>
                          <select
                            className="form-control"
                            value={length}
                            required
                            onChange={(e) => setLength(e.target.value)}
                          >
                            {" "}
                            <option value="">Select</option>
                            {[
                              8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56,
                              60, 64, 68, 72, 76, 80, 84, 88, 92, 96, 100, 104,
                              108, 112, 116, 120, 124, 128, 132, 136, 140, 144,
                            ].map((number) => (
                              <option key={number} value={number}>
                                {number} Mtr
                              </option>
                            ))}
                          </select>
                          {errors.length && (
                            <small className="text-danger">
                              {errors.length}
                            </small>
                          )}
                        </div>

                        <div className="mb-3">
                          <label className="form-label required">
                            Polyhouse Width (8mtr)
                          </label>
                          <select
                            className="form-control"
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                            required
                          >
                            <option value="">Select</option>
                            {[
                              12, 20, 28, 36, 44, 52, 60, 68, 76, 84, 92, 100,
                              108, 116, 124, 132, 140, 148, 156, 164, 172, 180,
                              188, 196, 204, 212, 220, 228, 236, 244, 252, 260,
                              268, 276,
                            ].map((number) => (
                              <option key={number} value={number}>
                                {number} Mtr
                              </option>
                            ))}
                          </select>

                          {errors.width && (
                            <small className="text-danger">
                              {errors.width}
                            </small>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label required">
                            Hydroponic Type
                          </label>
                          <div className="d-flex">
                            <div className="form-check me-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hydroponicType"
                                value="flatbed"
                                checked={hydrponicType === "flatbed"}
                                onChange={(e) =>
                                  setHydrponicType(e.target.value)
                                }
                                required
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flatbed"
                              >
                                Flatbed
                              </label>
                            </div>
                            <div className="form-check me-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hydroponicType"
                                value="growbags"
                                checked={hydrponicType === "growbags"}
                                onChange={(e) =>
                                  setHydrponicType(e.target.value)
                                }
                                required
                              />
                              <label
                                className="form-check-label"
                                htmlFor="growbags"
                              >
                                Growbags
                              </label>
                            </div>
                            <div className="form-check me-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hydroponicType"
                                value="foggers"
                                checked={hydrponicType === "foggers"}
                                onChange={(e) =>
                                  setHydrponicType(e.target.value)
                                }
                                required
                              />
                              <label
                                className="form-check-label"
                                htmlFor="foggers"
                              >
                                Foggers
                              </label>
                            </div>
                            <div className="form-check me-2">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hydroponicType"
                                value="cea-nvph"
                                checked={hydrponicType === "cea-nvph"}
                                onChange={(e) =>
                                  setHydrponicType(e.target.value)
                                }
                                required
                              />
                              <label
                                className="form-check-label"
                                htmlFor="cea-nvph"
                              >
                                CEA-NVPH
                              </label>
                            </div>
                          </div>
                          {errors.hydrponicType && (
                            <small className="text-danger">
                              {errors.hydrponicType}
                            </small>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label required">
                            Client Project
                          </label>
                          <select
                            className="form-select"
                            value={clinetProject}
                            onChange={(e) => setClientProject(e.target.value)}
                            required
                          >
                            <option value="Select">Select</option>
                            <option value="">Select project</option>
                            {projects &&
                              projects?.map((pro) => {
                                return (
                                  <option
                                    key={pro.clientName}
                                    value={pro.clientName}
                                  >
                                    {pro.clientName}
                                  </option>
                                );
                              })}
                          </select>
                          {errors.clinetProject && (
                            <small className="text-danger">
                              {errors.clinetProject}
                            </small>
                          )}
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary me-2"
                          onClick={handleSubmit}
                        >
                          <CiCalculator1 className="me-1" />
                          CALCULATE
                        </button>

                        <button
                          type="button"
                          className="btn btn-muted"
                          onClick={() => {
                            setLength("");
                            setWidth("");
                            setHydrponicType("");
                            setClientProject("");
                            setErrors({});
                          }}
                        >
                          RESET
                        </button>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-9 col-sm-12 py-2">
                    <div className="card">
                      <Formik
                        initialValues={materialPlanning}
                        validationSchema={materialPlaningSchemaNew}
                        onSubmit={handleSubmit}
                      >
                        {(props) => (
                          <Form>
                            <div className="card-body">
                              <div className="mb-3 row">
                                <label className="w-25 form-label required">
                                  Client Project
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect type="text" name="clientName">
                                    <option value="">Select project</option>
                                    {projects &&
                                      projects?.map((pro) => {
                                        return (
                                          <option
                                            key={pro.clientName}
                                            value={pro.clientName}
                                          >
                                            {pro.clientName}
                                          </option>
                                        );
                                      })}
                                  </CustomSelect>
                                  {props.touched.clientName &&
                                    props.errors.clientName && (
                                      <p className="text-danger">
                                        {props.errors.clientName}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Polyhouse Length (4mtr)
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect type="number" name="bay_size">
                                    <option value="">Select</option>
                                    {[
                                      8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48,
                                      52, 56, 60, 64, 68, 72, 76, 80, 84, 88,
                                      92, 96, 100, 104, 108, 112, 116, 120, 124,
                                      128, 132, 136, 140, 144,
                                    ].map((number) => (
                                      <option key={number} value={number}>
                                        {number} Mtr
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  {props.touched.bay_size &&
                                    props.errors.bay_size && (
                                      <p className="text-danger">
                                        {props.errors.bay_size}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Polyhouse Width (8mtr)
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect type="number" name="span_size">
                                    <option value="">Select</option>
                                    {[
                                      12, 20, 28, 36, 44, 52, 60, 68, 76, 84,
                                      92, 100, 108, 116, 124, 132, 140, 148,
                                      156, 164, 172, 180, 188, 196, 204, 212,
                                      220, 228, 236, 244, 252, 260, 268, 276,
                                    ].map((number) => (
                                      <option key={number} value={number}>
                                        {number} Mtr
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  {props.touched.span_size &&
                                    props.errors.span_size && (
                                      <p className="text-danger">
                                        {props.errors.span_size}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required">
                                  Hydroponic type
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect
                                    type="text"
                                    name="hydrponicType"
                                  >
                                    <option value="">Select</option>
                                    <option value="flatbed">flatbed</option>
                                    <option value="growbags">growbags</option>
                                    <option value="foggers">foggers</option>
                                    <option value="cea-nvph">cea-nvph</option>
                                    {/* <option value="hydroponicsOnly">
                                      Hydroponics Only
                                    </option> */}
                                  </CustomSelect>
                                  {props.touched.hydrponicType &&
                                    props.errors.hydrponicType && (
                                      <p className="text-danger">
                                        {props.errors.hydrponicType}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Vehical Type
                                </label>
                                <div className="w-100 col">
                                  <CustomInput name="vehicalNum" type="text" />
                                  {props.touched.vehicalNum &&
                                    props.errors.vehicalNum && (
                                      <p className="text-danger">
                                        {props.errors.vehicalNum}
                                      </p>
                                    )}
                                </div>
                              </div>
                              {/* {props.values.hydrponicType ===
                              "hydroponicsOnly" ? (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    A-Frame percent
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="number"
                                      name="a_FramePercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.a_FramePercent &&
                                      props.errors.a_FramePercent && (
                                        <p className="text-danger">
                                          {props.errors.a_FramePercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )} */}
                              {/* {props.values.hydrponicType ===
                              "hydroponicsOnly" ? (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Flat-NFT percent
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="number"
                                      name="flatBedPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.flatBedPercent &&
                                      props.errors.flatBedPercent && (
                                        <p className="text-danger">
                                          {props.errors.flatBedPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                              {props.values.hydrponicType ===
                              "hydroponicsOnly" ? (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Grow Bag percent
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="number"
                                      name="growBagPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.growBagPercent &&
                                      props.errors.growBagPercent && (
                                        <p className="text-danger">
                                          {props.errors.growBagPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )} */}
                              {/* {props.values.hydrponicType ===
                              "hydroponicsOnly" ? (
                                <div className="mb-3 row">
                                  <label className="w-25 form-label col-3">
                                    Dutch Bucket percent
                                  </label>
                                  <div className="w-100 col">
                                    <CustomSelect
                                      type="number"
                                      name="dutchBucketPercent"
                                    >
                                      <option value="">Select</option>
                                      <option value={0}>0%</option>
                                      <option value={25}>25%</option>
                                      <option value={50}>50%</option>
                                      <option value={75}>75%</option>
                                      <option value={100}>100%</option>
                                    </CustomSelect>
                                    {props.touched.dutchBucketPercent &&
                                      props.errors.dutchBucketPercent && (
                                        <p className="text-danger">
                                          {props.errors.dutchBucketPercent}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )} */}
                            </div>

                            <div className="card-footer">
                              <div className="btn-list justify-content-end">
                                <FormSubmitButton buttonText="Calculate" />

                                <SimpleButton
                                  buttonText="Cancel"
                                  type="secondary"
                                />
                              </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default HydroponicMaterialPlanning;
